module.exports = __webpack_public_path__ + "img/circleGreen3.fa5402e7.svg";